import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Card,
  Action,
  Button,
  Input,
  InputError,
  CheckboxOption,
  Spinner,
} from '@foodsby/nutrient'
import { loadLocationStart } from '../redux/modules/location'
import { api } from '../api/api'
import { loginStart } from '../redux/modules/user'
import { normalizeUserCreationError } from '../util/errorUtils'
import { termsAndConditionsRoute } from '../routes/routes'
import { Formik } from 'formik'
import { string, boolean, object } from 'yup'
import { friendsRoute } from '../routes/routes'

const schema = object().shape({
  password: string()
    .required('Password is required.')
    .min(8, 'Fudge 🍫! Your password must be at least 8 characters.'),
  TOS: boolean()
    .required('You must accept the Terms and Conditions Agreement')
    .oneOf([true], 'You must accept the Terms and Conditions Agreement'),
})

function getQueryVariable(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}

const newLocationId = getQueryVariable('newLocationId')

class PageCompleteAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      passwordShowing: false,
      error: false,
      loading: false,
      username: '',
      locationId: 0,
      password: '',
      submitLoading: false,
      successMessage: '',
      errorMessage: '',
      connectionId: null,
      redirecting: false,
    }

    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.login = this.login.bind(this)
  }

  togglePasswordVisibility() {
    this.setState(prevState => ({
      passwordShowing: !prevState.passwordShowing,
    }))
  }

  componentDidMount() {
    const {
      match: {
        params: { token },
      },
    } = this.props
    api
      .get(`/api/v1/uaa/users/inviteCode/${token}`)
      .then(data => {
        this.setState({
          username: data.username,
          connectionId: data.connectionId,
        })
        // Checks the URL if there is a new location ID, if not, it will just use the location ID from the token
        if (newLocationId) {
          this.setState({ locationId: newLocationId })
        } else {
          this.setState({ locationId: data.locationId })
        }

        this.props.loadLocationStart(this.state.locationId)
      })
      .catch(error => {
        this.setState({
          errorMessage: normalizeUserCreationError(error),
          submitLoading: false,
        })
      })
  }

  login() {
    const loginPayload = {
      userName: this.state.username,
      password: this.state.password,
      connectionId: this.state.connectionId,
    }
    this.props.loginStart(loginPayload)
  }

  handleSubmit(event) {
    this.setState({ submitLoading: true, password: event.password }, () => {
      this.login()
      const {
        match: {
          params: { token },
        },
      } = this.props
      const payload = {
        locationId: this.state.locationId,
        password: this.state.password,
      }

      api
        .put(`/api/v1/uaa/users/inviteCode/${token}/confirm`, payload)
        .then(() => {
          this.setState({
            successMessage:
              'Success! Your password has been created. Logging you in...',
          })
          let _this = this
          setTimeout(() => {
            _this.login()
          }, 2500)
        })
        .catch(error => {
          if (error.response) {
            this.setState({
              errorMessage: normalizeUserCreationError(error.response),
              submitLoading: false,
            })
          }
        })
    })
  }

  handleChange(event) {
    this.setState({ password: event.target.value })
  }

  componentDidUpdate() {
    let { locationSearch, history, isAuthenticated } = this.props
    if (!this.state.redirecting && isAuthenticated && history) {
      this.setState({ redirecting: true }, () => {
        setTimeout(() => {
          history.push(friendsRoute.path)
        }, 1000)
      })
    }
    const {
      match: {
        params: { token },
      },
    } = this.props
    let foundLocations = locationSearch.locations.foundLocations

    if (foundLocations != null) {
      if (foundLocations.length === 1) {
        this.setState({
          locationId: foundLocations[0].id,
        })
        window.location.href = `/complete-account/${token}/?newLocationId=${foundLocations[0].id}`
      }
    }
  }

  render() {
    return (
      <div className="complete-account-article">
        <Card>
          <div className="row center-xs" style={{ marginBottom: '16px' }}>
            <h2>Complete Your Account</h2>
          </div>
          <div className="row segment">
            <div className="col-xs-12">
              <label>Email:</label>
              <p className="segment-text">{this.state.username}</p>
              <div className="col end-xs" style={{ marginBottom: '10px' }}>
                <Action
                  onClick={this.togglePasswordVisibility}
                  style={{ fontSize: '15px' }}
                >
                  {this.state.passwordShowing
                    ? 'Hide Pasword'
                    : 'Show Password'}
                </Action>
              </div>
              <Formik
                gtm-data-elm-id="CompleteAccountform"
                initialValues={{
                  password: '',
                  TOS: false,
                }}
                onSubmit={this.handleSubmit}
                validationSchema={schema}
              >
                {({
                  touched,
                  errors,
                  handleChange,
                  handleBlur,
                  values,
                  handleSubmit,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="row start-xs">
                      <div className="col-xs-12 _lr-hide">
                        <Input
                          className="confirmPassword"
                          id="completeAccountPassword"
                          isValid={!errors.password}
                          label="Create Password"
                          name="password"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          tabIndex="2"
                          type={
                            this.state.passwordShowing ? 'text' : 'password'
                          }
                          value={values.password}
                        />
                        <InputError>
                          {touched.password && errors.password}
                        </InputError>
                      </div>
                      <div className="col-xs-12 checkbox">
                        <CheckboxOption
                          checked={values.checkbox}
                          id="checkbox"
                          label={
                            <small>
                              By signing up, you agree to our{' '}
                              <a
                                href={termsAndConditionsRoute.path}
                                rel="noopener noreferrer"
                                style={{ display: 'inline' }}
                                target="_blank"
                              >
                                <small>Terms and Conditions Agreement</small>
                              </a>
                            </small>
                          }
                          name="TOS"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          required
                          type="checkbox"
                        />
                        <InputError>{touched.TOS && errors.TOS}</InputError>
                      </div>
                      <div className="col-xs-12 center-xs">
                        <Button
                          disabled={
                            this.state.submitLoading ||
                            errors.password ||
                            errors.TOS
                          }
                          style={{ marginTop: '16px' }}
                          type="submit"
                        >
                          {this.state.submitLoading && (
                            <Spinner className="spinner-xs" />
                          )}{' '}
                          Submit
                        </Button>
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
              <div className="success">{this.state.successMessage}</div>
              <div className="error">{this.state.errorMessage} </div>
              {this.state.errorMessage && (
                <div>
                  Already have an account?
                  <br />
                  Please try logging in <a href="/login">here</a>
                </div>
              )}{' '}
            </div>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const locationSearch = state.locationSearch
  const { isAuthenticated } = state.user

  return {
    isAuthenticated,
    locationSearch,
  }
}

const mapDispatchToProps = {
  loadLocationStart,
  loginStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageCompleteAccount)
